import { useCallback as n } from "react";
import { generateEntityId as c } from "@material-bank/ds-utils";
import { createStore as l } from "./store.js";
const d = l(
  (t) => ({
    toasts: [],
    addToast: (s, o) => t(
      (a) => {
        const { showStack: r = !1 } = o ?? {}, e = { ...s, id: c() };
        return {
          toasts: r ? [e].concat(a.toasts) : [e]
        };
      },
      !1,
      "toasts/addToast"
    ),
    deleteToast: (s) => t(
      (o) => ({
        toasts: o.toasts.filter((a) => a.id !== s)
      }),
      !1,
      "toasts/deleteToast"
    ),
    clearToasts: () => t(() => ({ toasts: [] }), !1, "toasts/clearToasts")
  }),
  { name: "Toasts" }
), m = () => {
  const t = d.use.addToast(), s = n(
    (o) => {
      t(
        {
          variant: "error",
          title: "Something went wrong. Please try again.",
          ...o
        },
        { showStack: !0 }
      );
    },
    [t]
  );
  return { showToast: t, showErrorToast: s };
};
export {
  m as useToast,
  d as useToastsStore
};
